import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestList.XeroMatchingV2Section.BillView.ChangeMatchingPopup.ChangeMatchingPopupBody.PanelEmpty',
    {
        noPOMatchingFilter: 'No Purchase Orders were found',
    }
);
